// Keep the approval preview aligned with the server-side payout calculation.
const calculateFinalPayBreakdown = subtotal => {
  const fee = subtotal * 0.05;

  return {
    fee: Number(fee.toFixed(2)),
    finalPay: Number((subtotal - fee).toFixed(2)),
  };
};

export default calculateFinalPayBreakdown;
